import React from 'react';

import {
  CalculationMethods,
  manualDefaultApplyToMethods,
  manualDefaultApplyPercentageToMethods,
  ManualDefaultApplyTo,
} from '../../models';
import { SummaryFieldTitle, SummaryFieldValue } from '../shared/styled';
import { useDiscountWizardStateContext } from '../state';

export function Reward() {
  const {
    isManualDiscount,
    rewardsStepState: { amountOff, discountMethod, manualApplyToMethod, percentOff },
  } = useDiscountWizardStateContext();

  const reward = getCurrentReward({ amountOff, discountMethod, isManualDiscount, manualApplyToMethod, percentOff });
  return (
    <>
      <SummaryFieldTitle>Reward:</SummaryFieldTitle>
      <SummaryFieldValue>{reward}</SummaryFieldValue>
    </>
  );
}

export function getCurrentReward({
  amountOff,
  discountMethod,
  isManualDiscount,
  manualApplyToMethod,
  percentOff,
}: {
  amountOff: number | '';
  discountMethod: CalculationMethods | 0;
  isManualDiscount: boolean;
  manualApplyToMethod: ManualDefaultApplyTo | 0;
  percentOff: number | '';
}) {
  const amountText = amountOff === '' ? '_' : `$${amountOff}`;
  const percentText = percentOff === '' ? '_' : `${percentOff}%`;
  if (isManualDiscount) {
    const manualDefaultApplyToOptions =
      discountMethod === CalculationMethods.PercentOff
        ? manualDefaultApplyPercentageToMethods
        : manualDefaultApplyToMethods;
    let applyToText =
      manualDefaultApplyToOptions
        .find((method) => method.val === manualApplyToMethod)
        ?.name.toLowerCase()
        .replace('apply', 'applied') || '';

    if (manualApplyToMethod !== ManualDefaultApplyTo.DistributedAmongEveryItem && applyToText !== '') {
      applyToText = `for ${applyToText}`;
    }

    switch (discountMethod) {
      case CalculationMethods.AmountOff:
      case CalculationMethods.AmountOffTotal: // technically the user should not be able to set this for manual discounts; added for completeness
        return `${amountText} off ${applyToText}`.trim();
      case CalculationMethods.PercentOff:
        return `${percentText} off ${applyToText}`.trim();
      case CalculationMethods.PriceToAmount:
      case CalculationMethods.PriceToAmountTotal: // technically the user should not be able to set this for manual discounts; added for completeness
        return `${amountText} price ${applyToText}`.trim();
      case CalculationMethods.PriceToCostPlusPercent:
        return `Wholesale cost plus ${percentText} ${applyToText}`.trim();
      default:
        return '';
    }
  } else {
    switch (discountMethod) {
      case CalculationMethods.AmountOff:
        return `${amountText} off each item`;
      case CalculationMethods.AmountOffTotal:
        return `${amountText} off total order`;
      case CalculationMethods.PercentOff:
        return `${percentText} off each item`;
      case CalculationMethods.PriceToAmount:
        return `${amountText} price for each item`;
      case CalculationMethods.PriceToAmountTotal:
        return `${amountText} price for total order`;
      case CalculationMethods.PriceToCostPlusPercent:
        return `Wholesale cost plus ${percentText}`;
      default:
        return '';
    }
  }
}
